import React from "react";

export default class YandexRecWidget extends React.Component {
    componentDidMount() {
        window.yaContextCb.push(() => {
            Ya.Context.AdvManager.renderWidget({
                renderTo: "yandex_rtb_C-A-1598227-14",
                blockId: "C-A-1598227-14",
            });
        });
    }

    render() {
        return <div id="yandex_rtb_C-A-1598227-14"></div>;
    }
}
